import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';

import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
};

class ExternalLinkListView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
    };
  }

 componentDidMount() {
    // console.log("Into TSX")
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()
  
    return actions
  }

  handleRowClick = (item) => {
    // console.log("Opening", item)
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/externallinks/admin/${item.id}`
  }

  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status} = this.state;

    var criteriaSelector = {
      "app": "admin",
      "form": "externallinkCriteria"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      criteriaSelector["userType"] = "Internal"
    }

    switch (status) {
      case 'loading':
        return (
          <AppView>
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
          </AppView>
        );
      default:
        return (
          <AppView>
            <div className={classes.container}>
                <QueryList
                  criteriaFormSelector={criteriaSelector}
                  resultsFormSelector={
                    {
                      "app":"externallinks",
                      "form":"userExternalLinksList"
                    }
                  }
                  // Mock URL
                  queryUrl="/api/portal-externallinks/query/list"
                  forceExecuteOnLoad={true}
                  autoQuery={true}
                  supressSectionStatusIcon
                  suppressCriteriaView={true}
                //   actionsForItemRow={this.handleActionsForItemRow}
                //   onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{}}
                  // excludeFromClear={["supplierID","vendorNbrs"]}
                  noResultsText="No Results Found"
              />
            </div>
          </AppView>
        );
    }
  }
}

export default withStyles(styles)(ExternalLinkListView);



